export default {
    name: "OverdueActivitiesWidget",
    type: "DataWidget",
    description: "Displays a list of the student's missed or overdue activities.",
    roles: ["student"],
    widget: {
        title: "Overdue Activities",

        // --- FIX: Add dataProvider with a transform function ---
        dataProvider: {
            main: {
                rpc: "StudentRpc.getOverdueActivities",
                transform: (response) => {
                    response?.data || []
                }
            }
        },

        itemTemplate: (item) => {
            const iconMap = {
                class: 'bi-camera-video-fill text-info',
                assessment: 'bi-clipboard2-check-fill text-warning',
                assignment: 'bi-file-earmark-arrow-up-fill text-success'
            };
            const iconClass = iconMap[item.topicType] || 'bi-question-circle-fill';
            const overdueTime = new Date(item.scheduledDateTime);

            return `
                <a href="/student/schedule" class="text-decoration-none text-reset list-group-item list-group-item-action">
                    <div class="d-flex align-items-center">
                        <i class="bi ${iconClass} fs-4 me-3"></i>
                        <div class="flex-grow-1">
                            <div class="fw-bold">${item.topicTitle}</div>
                            <small class="text-danger fw-bold">Due ${overdueTime}</small>
                        </div>
                        <span class="badge bg-danger-subtle text-danger-emphasis rounded-pill">Take Now</span>
                    </div>
                </a>
            `;
        },
        noDataMessage: "Great job! No overdue activities."
    }
};
